import { Flow_0_0_2 } from '@flexus/core';

export const BUI_10: Flow_0_0_2 = {
	id: '10',
	name: 'work_complete_claim',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: 'Placeholder'
		},
		viewRoles: {
			0: 'Placeholder'
		}
	},
	startNode: '',
	nodes: {}
};
